import { useModal } from './useModal';

export const useModalWithConfirmation = () => {
  const modal = useModal();
  const confirmationModal = useModal();

  return {
    modal: {
      isOpened: modal.isOpened,
      visuallyHidden: confirmationModal.isOpened,
      onOpen: modal.onOpen,
      onClose: modal.onClose,
    },
    confirmationModal,
  };
};
